import store from '@/store';
export const option = {
    height: 'auto',
    calcHeight: 80,
    tip: false,
    delBtn: false,
    editBtn: false,
    addBtn: false,
    searchShow: true,
    selection: true,
    searchMenuSpan: 6,
    searchLabelWidth: 100,
    labelWidth: 150,
    border: true,
    index: false,
    indexLabel: '序号',
    viewBtn: false,
    dialogType: 'dialog',
    dialogClickModal: false,
    column: [{
            label: "订单编号",
            prop: "businessCode",
            display: false,
        },
        {
            label: "租赁人",
            prop: "name",
            type: "input",
            search: true,
            searchPlaceholder: "请输入租赁人",
            display: false,
        },
        {
            label: "所属代理商",
            prop: "businessDeptIdList",
            type: "select",
            filterable: true,
            multiple: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            search: true,
            searchMultiple: true,
            searchClearable: true,
            defaultExpandAll: true,
            searchOrder: 1000,
            hide: true,
            dicData: [],
            props: {
                label: "title",
                value: "id",
            },
        },
        {
            label: "产品类型",
            prop: "rentTypeList",
            type: "select",
            display: false,
            search: true,
            searchMultiple: true,
            hide: true,
            showColumn: false,
            dicData: store.getters.porductTypes
        },
        {
            label: "手机号",
            prop: "phoneNumber",
            span: 24,
            display: false,
        },
        {
            label: "产品类型",
            prop: "rentType",
            display: false,
            type: "select",
            dicData: store.getters.porductTypes

        },
        {
            label: "车牌号",
            prop: "carFirstNumber",
            span: 24,
            search: false,
            display: false,
        },
        {
            label: "id",
            prop: "id",
            display: false,
            hide: true,
        },
        {
            label: "起租日",
            prop: "commencementDate",
            type: "daterange",
            search: true,
            searchRange: true,
            valueFormat: "yyyy-MM-dd",
            search: true,
            hide: true,
            display: false,
        },
        {
            label: "提交日期",
            prop: "submitDate",
            type: "daterange",
            search: true,
            searchRange: true,
            valueFormat: "yyyy-MM-dd",
            search: true,
            hide: true,
            display: false,
        },
        {
            label: "所属代理商",
            prop: "businessDeptName",
            span: 24,
            display: false,
        }
    ],
}
